const AttributesFilters = [
    "Color",
    "Fabric",
    "Hand",
    "Material",
    "Artwork",
    "Artist",
    "Effect",
    "Techniques",
    "Era",
]

export default function calculateFilterString(FilterData) {
    let filterString = "";
    //More FIlters IMplementations
    if (FilterData["null___already_shared_with_these_clients"]) {
        filterString += "&null___already_shared_with_these_clients=1";
    }
    // if (FilterData["null___shared_with_clientid"]) {
    //     filterString += "&null___shared_with_clientid=1";
    // }
    if (FilterData["notnull___shared_with_clientid"]) {
        filterString += "&notnull___shared_with_clientid=1";
    }
    if (FilterData["equalto___handed_over_to_client"]) {
        filterString += "&equalto___handed_over_to_client=1";
    }
    if (FilterData["equalto___handed_over_to_an_employee_for_internal_use"]) {
        filterString += "&equalto___handed_over_to_an_employee_for_internal_use=1";
    }
    if (FilterData["equalto___handed_over_to_an_employee_for_showcasing"]) {
        filterString += "&equalto___handed_over_to_an_employee_for_showcasing=1";
    }
    if (FilterData["null___collection_code"]) {
        filterString += "&null___collection_code=1"
    }
    if (FilterData["notDispatchOrOutOnLoan"]) {
        filterString += `&state=Draft,Available`
    }

    //Attributes
    let isAll = FilterData["filterType"] === "all";
    AttributesFilters.forEach((attr) => {
        if (FilterData[attr].length > 0) {
            let queryParam = "&excludeall___";
           
            if (attr === "Fabric") {
                queryParam += "basic_fabric";
            }
            else {
                queryParam += attr.toLowerCase();
            }

            filterString += `${queryParam}=${FilterData[attr].join(",")}`;
        }
    });

    const attributesFilters = FilterData.attributes.reduce((acc, item) => ({...acc, [item.type]: [...(acc[item.type] || []), item.label]}), {})

    Object.entries(attributesFilters).forEach(([type, value]) => {
        let queryParam = "&";
        if (type === "Tag") {
            queryParam += "cd";
        }
        if (isAll) {
            queryParam += "containsall___";
        } else{
            queryParam += "containsany___";
        }
       
        if (type === "Fabric") {
            queryParam += "basic_fabric";
        }
        else {
            queryParam += type.toLowerCase();
        }

        filterString += `${queryParam}=${value.join(",")}`;
    });

    // Primary filters
    if (FilterData.cdnullorzero___first_approved_on) {
        filterString += `&cdnullorzero___first_approved_on=${FilterData.cdnullorzero___first_approved_on}`;
    }

    //Primary 
    if (FilterData.Status !== "") {
        const statusFIlterMapping = {
            'Draft': "Draft",
            'Rejected (Corrections needed)': "Rejected",
            'Available': "Available",
            'Issued to someone': "Unavailable",
            'Used by': "Sold"
        };
        filterString += `&state=${statusFIlterMapping[FilterData.Status]}`;
    }
    
    if (FilterData.Search !== "") {
        // filterString += `&search=${FilterData.Search}`;
        filterString += `&search=${FilterData.Search}`;
        
        // if (searchQuery !== FilterData.Search) {
        //     setSearchQuery("");
        // }
    }
    if (FilterData.UniqueCodes.length>0) {
        filterString += `&unique_codes=${FilterData.UniqueCodes.join(",")}`;
    }

    //location
    if (FilterData.subquery___amal_sharing___fk_client___fk_card___id !== "") {
        filterString += `&subquery___amal_sharing___fk_client___fk_card___id=${FilterData.subquery___amal_sharing___fk_client___fk_card___id}`;
    }
    if (FilterData.containsany___location_id.length > 0) {
        filterString += `&containsany___location_id=${FilterData.containsany___location_id.join(",")}`;
    }
    if (FilterData.equalto___handed_over_to_userid !== "") {
        filterString += `&equalto___handed_over_to_userid=${FilterData.equalto___handed_over_to_userid}`;
    }
    if (FilterData.sharedTillDate.start && FilterData.sharedTillDate.end) {
        filterString += `&datetime1_from=${FilterData.sharedTillDate.start.format('YYYY-MM-DD HH:mm:ss')}`;
        filterString += `&datetime1_to=${FilterData.sharedTillDate.end.format('YYYY-MM-DD')} 23:59:59`;
    }
    if (FilterData.returnDate.start && FilterData.returnDate.end) {
        filterString += `&datetime2_from=${FilterData.returnDate.start.format('YYYY-MM-DD HH:mm:ss')}`;
        filterString += `&datetime2_to=${FilterData.returnDate.end.format('YYYY-MM-DD')} 23:59:59`;
    }
    if (FilterData.boxNumber !== "") {
        // if (type === "Tag") {
        //     queryParam += "cd";
        // }
        // if (isAll) {
        //     queryParam += "containsall___";
        // } else{
        //     queryParam += "containsany___";
        // }


        filterString += `&cdcontainsall___box_number=${FilterData.boxNumber}`;

    }

    // Never liked filter
    if (FilterData.neverLiked) {
        filterString += "&cdnullorzero___total_likes=1";
    }

    // Sort parameter
    if (FilterData.sortBy) {
        filterString += `&sort_by=${FilterData.sortBy}`;
    }

    return filterString;
}
